// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tox.tox-tinymce .tox-statusbar{border:none}.tox.tox-tinymce .tox-statusbar .tox-statusbar__resize-handle svg,.tox.tox-tinymce .tox-statusbar .tox-statusbar__text-container{display:none}.tox.tox-tinymce .tox-statusbar .tox-statusbar__resize-handle:after{content:\"\";position:absolute;right:2px;bottom:2px;width:0;height:0;border-left:8px solid transparent;border-top:8px solid transparent;border-bottom:8px solid var(--v-gray-light)}", ""]);
// Exports
module.exports = exports;
